// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eoev-widget .v-row-group__header{font-weight:700;font-size:22px}.eoev-widget td{border-bottom:1.5px solid #9e9e9d!important}.eoev-widget .comment{white-space:pre-line}.eoev-widget .cancelled__event{text-decoration:line-through;color:red!important;font-weight:400!important}", ""]);
// Exports
module.exports = exports;
